import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import * as component from '../../pages/index';
import { routeData } from './constant';
import initialRenderApis from '../../api/config/initialRenderApis';
import { hasModule, getLegacyEntitlements, getAllModules } from '../../utils/capabilitiesHelper';
import { getFilteredRouteData } from '../../utils/entitlementsHelper';
import { getCategoriesFromStorage } from '../../utils/apiCacheHelper';
import { fetchCategoriesSuccess } from '../../store/categoriesSlice';
import NoModulesMessage from '../../components/shared/NoModulesMessage';
import { PostLoginGateSkeleton } from '../../pages/whatsapp/components/skeletons/WhatsAppPageSkeletons';

const Default = component.Dashboard;

const getDefaultRoute = (capabilities) => {
  if (hasModule(capabilities, 'CRM')) {
    return '/home/dashboard';
  }

  if (hasModule(capabilities, 'WHATSAPP')) {
    return '/whatsapp/dashboard';
  }

  return null;
};

const RoutesAfterLogin = () => {
  const dispatch = useDispatch();
  const capabilities = useSelector((state) => state.capabilities.capabilities);
  
  const legacyEntitlements = getLegacyEntitlements(capabilities);
  const filteredRoutes = getFilteredRouteData(routeData, legacyEntitlements);
  const defaultRoute =
    getDefaultRoute(capabilities) ?? filteredRoutes?.[0]?.url ?? null;
  const hasCRM = hasModule(capabilities, 'CRM');
  const userModules = getAllModules(capabilities);
  const hasNoModules = userModules.length === 0;
  const capabilitiesLoading = useSelector((state) => state.capabilities.loading);
  const accountSetupLoading = useSelector((state) => state.accountSetup.isLoading);
  const isCapabilitiesAuthorized = capabilities?.isAuthorized || false;

  useEffect(() => {
    if (hasCRM) {
      const cachedCategories = getCategoriesFromStorage();
      if (cachedCategories) {
        dispatch(fetchCategoriesSuccess(cachedCategories));
      } else {
        initialRenderApis(dispatch);
      }
    }
  }, [hasCRM, dispatch]);

  if (capabilitiesLoading || accountSetupLoading) {
    return <PostLoginGateSkeleton />;
  }

  if (hasNoModules && isCapabilitiesAuthorized) {
    return <NoModulesMessage />;
  }

  return (
    <Routes>
      {CreateRoute(filteredRoutes, defaultRoute)}
    </Routes>
  )
}

const CreateRoute = (routeData, defaultRoute) => {
  return (
      <>
          {
              routeData ? routeData.map((route) => {
                  const { id, url, componentName, children } = route;
                  return (
                      <React.Fragment key={id}>
                          <Route path={url} element={<Dynamicomponent componentName={componentName} />} />
                          {/* If route has children, create routes for them too */}
                          {children && children.map((child) => (
                              <Route 
                                  key={`child-${child.id}`}
                                  path={child.url} 
                                  element={<Dynamicomponent componentName={child.componentName} />} 
                              />
                          ))}
                      </React.Fragment>
                  )
              }) : ''
          }
          {defaultRoute ? (
            <>
              <Route path="/" element={<Navigate to={defaultRoute} replace />} />
              <Route path="*" element={<Navigate to={defaultRoute} replace />} />
            </>
          ) : null}
      </>
  )
}

const Dynamicomponent = ({ componentName }) => {
  const dynamicComp = component[componentName] || Default;
  return React.createElement(dynamicComp);
}

export default RoutesAfterLogin
